import type { TierHero } from '../types';
import { heroDisplayName } from '../utils/heroDisplayName';

interface TierTooltipProps {
  hero: TierHero;
  beta: number;
  position: { top: number; left: number };
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

export function TierTooltip({ hero, beta, position, onMouseEnter, onMouseLeave }: TierTooltipProps) {
  // v3: font size fix
  return (
    <div 
      className="hero-tooltip"
      style={{
        top: position.top,
        left: position.left
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="tooltip-header">
        <strong>{heroDisplayName(hero.hero.hero_id, hero.hero.hero_name)}</strong>
      </div>
      <div className="tooltip-stats">
        <div className="stat">
          <span className="stat-label">勝率:</span>
          <span className="stat-value win">{(hero.hero.win_rate * 100).toFixed(1)}%</span>
        </div>
        <div className="stat">
          <span className="stat-label">ピック率:</span>
          <span className="stat-value pick">{(hero.hero.pick_rate * 1000).toFixed(1)}%</span>
        </div>
        <div className="stat">
          <span className="stat-label">BAN率:</span>
          <span className="stat-value ban">{(hero.hero.ban_rate * 100).toFixed(1)}%</span>
        </div>
        <div className="stat correction">
          <span className="stat-label">バンピック補正:</span>
          <span className="stat-value bonus">
            +{((10 * hero.hero.pick_rate * 100 + hero.hero.ban_rate * 100) * beta).toFixed(2)}
          </span>
        </div>
        <div className="stat tier-score">
          <span className="stat-label">ティアスコア:</span>
          <span className="stat-value highlight">{hero.tierScore.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
}
